import React, { useState } from "react"
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  FormControl,
  Input,
  Heading,
  Button,
  Flex,
  Text,
  IconButton,
} from "@chakra-ui/react"
import Icon from "../Icon/Icon"
import { useGiftRegistryContext } from "@app/providers/giftRegistry"
import { colors } from "@app/theme/colors"

const GiftRegistryPasswordDrawerDesktop = ({ registry, setDrawerOff, setUnlockRegistry }) => {
  const { state, setVal, handleInput, unlockRegistry } = useGiftRegistryContext()
  const [unlockRegistryResponse, setUnlockRegistryResponse] = useState<any>(false)
  const [isOpen, setIsOpen] = useState<any>(true)

  const handleUnlockRegistry = async e => {
    const unlockResponse = await unlockRegistry(e, registry?.Id)
    if (unlockResponse?.status === 200 && unlockResponse?.statusText == "OK") {
      setIsOpen(false)
      setTimeout(() => {
        setDrawerOff()
        window.location.href = `/gift-registry/view?id=${registry.Id}`
      }, 500)
    } else if (unlockResponse === "error") {
      setUnlockRegistryResponse("error")
    } else {
      setUnlockRegistryResponse(false)
    }
  }

  const handleCloseDrawer = () => {
    setIsOpen(false)
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTimeout(() => {
      setDrawerOff()
    }, 500)
  }

  return (
    <Drawer
      placement="right"
      isOpen={registry?.isPasswordProtected || registry?.settings?.isPasswordProtected ? isOpen : false}
      closeOnOverlayClick={false}
      onClose={() => {
        setVal("drawers.password", false)
      }}
    >
      <DrawerOverlay sx={{ backdropFilter: "blur(6px)" }} />
      <DrawerContent maxW="468px">
        <DrawerBody p={0}>
          <Box display="flex" justifyContent="end" width="100%" mt="20px">
            <IconButton
              textAlign="end"
              minW="unset"
              width="21px"
              height="21px"
              mr="20px"
              aria-label="close drawer"
              variant="ghost"
              icon={<Icon name="close" size="21px" />}
              onClick={handleCloseDrawer}
            />
          </Box>

          <Box h="100%" pl={4} pt={2} pr={4}>
            <Flex h="100%" flexDirection="column">
              <Flex flexGrow={1} flexDirection={"column"} justifyContent="center" maxWidth="322px" mx="auto">
                <Heading textAlign={"center"} as="h3" size="2xl" mb="42px" fontSize="30px" fontWeight="300" lineHeight="40px">
                  Please enter registry password
                </Heading>
                <form>
                  {unlockRegistryResponse == "error" ? (
                    <Text mb="10px" color="#EA2223">
                      Password incorrect
                    </Text>
                  ) : null}
                  <FormControl alignSelf={"flex-start"} w="auto" display={"flex"} pos={"relative"}>
                    <Input
                      value={state?.passwordProtectionForm.password}
                      onChange={e => handleInput("passwordProtectionForm.password", e.target.value)}
                      pl={2}
                      icon={false}
                      w="330px"
                      type={state?.passwordProtectionForm.visible ? "text" : "password"}
                      name="registry-password"
                      placeholder="Password"
                      autoComplete="new-password"
                      fontFamily={
                        state?.passwordProtectionForm.visible || state?.passwordProtectionForm.password === "" ? "inherit" : "password"
                      }
                    />
                    <Flex position="absolute" top={0} right={0} height="100%" alignItems="center" zIndex={1}>
                      {state?.passwordProtectionForm?.password.length > 6 ? (
                        <Icon key="tickGreen" name="tick" color="system.success.light" size="20px" mx="10px" />
                      ) : (
                        ""
                      )}
                      <Box w="1px" h="70%" bg={colors.neutrals.borders}></Box>
                      <Icon
                        cursor={"pointer"}
                        key={state?.passwordProtectionForm.visible ? "passwordShow" : "passwordHide"}
                        name={state?.passwordProtectionForm.visible ? "passwordShow" : "passwordHide"}
                        onClick={() => setVal("passwordProtectionForm.visible", !state?.passwordProtectionForm?.visible)}
                        color="text.icon"
                        size="20px"
                        mx="10px"
                      />
                    </Flex>
                  </FormControl>
                  <Button type="submit" onSubmit={unlockRegistry} onClick={e => handleUnlockRegistry(e)} variant="blue" mt="24px" w="100%">
                    CONTINUE
                  </Button>
                </form>
                <Text mt="42px" textAlign={"center"} fontWeight="bold" size="sm">
                  Not sure of the password?
                </Text>
                <Flex alignItems={"center"} justifyContent="center">
                  <Text textAlign="center" size="sm" maxW="250px">
                    Reach out to the owner of the registry to receive the access password.
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default React.memo(GiftRegistryPasswordDrawerDesktop)
